export default __webpack_public_path__ + "static/media/card4_right.9e45362f.png";